// extracted by mini-css-extract-plugin
export default {"container":"WheelWinnerPrize_container__XBSYG","balanceValue":"WheelWinnerPrize_balanceValue__sNpFB","currency":"WheelWinnerPrize_currency__o6XjL"};